import React, { useState, useEffect } from 'react';
import { Market } from '../../types/Market';

interface MarketFormProps {
  market: Market | null;
  onSubmit: (market: Market) => void;
  onCancel: () => void;
}

const MarketForm: React.FC<MarketFormProps> = ({ market, onSubmit, onCancel }) => {
  const [country, setCountry] = useState<string>('');
  const [isoCode, setIsoCode] = useState<string>('');
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (market) {
      setCountry(market.country);
      setIsoCode(market.isoCode);
    } else {
      setCountry('');
      setIsoCode('');
    }
  }, [market]);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    
    // Validate
    if (!country.trim()) {
      setError('Country name is required');
      return;
    }

    if (!isoCode.trim()) {
      setError('ISO code is required');
      return;
    }
    
    // Clear any previous errors
    setError(null);
    
    // Submit the form
    onSubmit({
      ...(market ? { id: market.id } : {}),
      country: country.trim(),
      isoCode: isoCode.trim().toUpperCase()
    });
  };

  return (
    <div className="form-container">
      <h2>{market ? 'Edit Market' : 'Add New Market'}</h2>
      
      {error && <div className="error-message">{error}</div>}
      
      <form onSubmit={handleSubmit}>
        <div className="form-group">
          <label htmlFor="country">Country</label>
          <input
            type="text"
            id="country"
            value={country}
            onChange={(e) => setCountry(e.target.value)}
            placeholder="Enter country name"
            autoFocus
          />
        </div>
        
        <div className="form-group">
          <label htmlFor="isoCode">ISO Code</label>
          <input
            type="text"
            id="isoCode"
            value={isoCode}
            onChange={(e) => setIsoCode(e.target.value.toUpperCase())}
            placeholder="Enter ISO code (e.g. US, GB)"
            maxLength={2}
            style={{ textTransform: 'uppercase' }}
          />
        </div>
        
        <div className="form-actions">
          <button 
            type="button" 
            className="secondary-button" 
            onClick={onCancel}
          >
            Cancel
          </button>
          <button 
            type="submit" 
            className="primary-button"
          >
            {market ? 'Update' : 'Create'} Market
          </button>
        </div>
      </form>
    </div>
  );
};

export default MarketForm; 